/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { Record } from "immutable";
const AbBooleanLogicSingleConditionContentDefaults = {
  cardinality: "SINGLE",
  key: "",
  disabled: false,
  selected: false
};
export class AbBooleanLogicSingleConditionContent extends Record(AbBooleanLogicSingleConditionContentDefaults) {
  constructor(key) {
    super({
      key: key
    });
  }
  with(values) {
    return this.merge(values);
  }
  withDisabled(isDisabled) {
    return this.with({
      disabled: isDisabled
    });
  }
  withSelected(isSelected) {
    return this.with({
      selected: isSelected
    });
  }
}
//# sourceMappingURL=AbBooleanLogicSingleConditionContent.js.map
